module.exports = __webpack_public_path__ + "120de61b60245fb34f38ff3c83d051e9.png";